import VoicesToday from "../Components/Voices/Overview/VoicesToday";

const VoicesTodayPage = () => {
  return <VoicesToday />;
};

export default VoicesTodayPage;
